import HelpTopic from './HelpTopic';

export default HelpTopic;
